import { html, LitElement } from 'lit-element';
/**
 * @element ct-modal-button
 * @prop {String} text - Button's title
 * @prop {Function} onClick - Button's function
 */
export class Button extends LitElement {
  static get properties() {
    return {
      text: { type: String, attribute: false },
      onClick: { type: Function, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`<button class="modal-close-button" @click=${this.onClick}>
      ${this.text}
    </button>`;
  }
}

export default Button;

export const CloseButtonText = 'Close';
